import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthFacade, AuthRoutes } from '@rx-applications/shared/auth/data-access';
import { TRANSLATION_SCOPE, translationProvider } from './i18n/translation.provider';
import { TranslocoDirective } from '@ngneat/transloco';
import { RxAlertModule, RxButtonModule, RxInputModule } from '@roomex/rx-components';
import { RouterLink } from '@angular/router';
import { addAbsolutePathPrefix } from '@rx-applications/shared/utils';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, UntypedFormGroup, Validators } from '@angular/forms';
import { PasswordMatchFormComponent, PasswordPolicyComponent } from '@rx-applications/shared/auth/ui';
import { FormUtils } from '@rx-applications/shared/utils-forms';

@Component({
  selector: 'rx-applications-shared-auth-feature-change-password',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoDirective,
    RxButtonModule,
    RouterLink,
    RxAlertModule,
    ReactiveFormsModule,
    RxInputModule,
    PasswordMatchFormComponent,
    PasswordPolicyComponent,
  ],
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  providers: [translationProvider],
})
export class ChangePasswordComponent extends FormUtils {
  protected readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE;
  protected readonly addAbsolutePathPrefix = addAbsolutePathPrefix;
  protected readonly authRoutes = AuthRoutes;
  authFacade: AuthFacade = inject(AuthFacade);
  formBuilder: FormBuilder = inject(FormBuilder);

  form: FormGroup = this.formBuilder.group({
    currentPassword: this.formBuilder.control('', [Validators.required]),
  });

  onSubmit(): void {
    if (this.form.invalid) {
      this.markAllAsTouched(this.form);
      return;
    }

    this.authFacade.changePassword(this.form.value.currentPassword, this.form.value.password);
  }
}
